import { createAction, createSlice } from '@reduxjs/toolkit';

export type BlogsData = {
    'employeeName': string,
    'imageUrl': string,
    'description': string,
    'dateOfJoining': string,
    'buzzBoardId': string,
    'buzzType': string,
    'link': string
}

const initialState: BlogsData[] = [];

export const revertAll = createAction('REVERT_ALL');

export const blogsReducer = createSlice({
    name: 'blogsReducer',
    initialState,
    reducers: {
        setBlogsData: (state, action) => {
            state = action.payload;
            return state;
        },
        addBlogsData: (state, action) => {
            state = [action.payload, ...state];
            return state;
        },
        updateBlogsData: (state, action) => {

            const indexOfReportToChange = state.findIndex(data => data.buzzBoardId === action.payload.buzzBoardId);
            const changedBlogsData = action.payload;

            state[indexOfReportToChange] = changedBlogsData;
            return state;
        },
        deleteBlogsData: (state, action) => {

            const indexOfBlogsDataToDelete = state.findIndex(data => data.buzzBoardId === action.payload.buzzBoardId);

            if (indexOfBlogsDataToDelete !== -1) {

                const savedData = state;
                state = [
                    ...savedData.slice(0, indexOfBlogsDataToDelete),
                    ...savedData.slice(indexOfBlogsDataToDelete + 1)];
            }
            return state;
        }

    }

});
export const { setBlogsData, addBlogsData, updateBlogsData, deleteBlogsData } = blogsReducer.actions;
export default blogsReducer;